import { type Key } from 'react-aria-components';
import { DropdownSelector } from '@repo/design-system-kit';
import type { OperatorOption } from '../../../types/filters';
import styles from './filters-list-header.module.css';

interface FiltersListHeaderProps {
  label: string;
  operator?: OperatorOption;
  operators?: OperatorOption[];
  onOperatorChange?: (operator: Key) => void;
}

export function FiltersListHeader({
  label,
  operator,
  operators,
  onOperatorChange,
}: FiltersListHeaderProps) {
  return (
    <div className={styles.container}>
      <span className={styles.label}>{label}</span>
      {operators && operators.length > 1 && onOperatorChange ? (
        <DropdownSelector
          buttonSize="sm"
          items={operators.map(op => ({ ...op, key: op.displayKey ?? op.key }))}
          onSelectionChange={onOperatorChange}
          selectedKey={operator?.displayKey ?? operator?.key}
        />
      ) : null}
    </div>
  );
}
